import script from "./PersonEvbActivationComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonEvbActivationComponent.vue?vue&type=script&setup=true&lang=ts"

import "./PersonEvbActivationComponent.vue?vue&type=style&index=0&id=c12bc1b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c12bc1b8"]])

export default __exports__